<template>
  <q-card v-if="selectedCustomer===''">
    <q-card-section class="no-padding">
      <q-form
          @submit="onSubmit"
          @reset="onReset">
        <q-input
            :dense="$q.screen.lt.md"
            filled
            autofocus
            v-model="customer.title"
            label="عنوان شرکت، شهر، منطقه، نوع فعالیت، عنوان طرف معامله و شماره تماس ..."
            hint="عنوان طرف معامله می تواند نام، نام خانوادگی و یا عنوان شرکت باشد"
        >
          <template v-slot:append>
            <q-btn icon="add"
                   flat
                   round
                   color="indigo"
                   @click="loadCustomerAddDialog"
                   v-if="isShopOrder">
              <q-tooltip>
                مشتری جدید
              </q-tooltip>
            </q-btn>
            <q-btn color="primary" flat round icon="settings"
                   v-if="false">
              <q-popup-proxy>
                <q-card flat>
                  <q-card-section>
                    <q-select
                        v-model="customer.company"
                        :options="companies"
                        option-label="CompName"
                        option-value="CompID"
                        label="شرکت"
                        use-chips
                        multiple
                    />
                    <q-select
                        v-model="customer.state"
                        label="استان"
                        :options="statesOptions"
                        option-label="State_Name"
                        option-value="State_ID"
                        @filter="filterFn"
                        use-chips
                        use-input
                        multiple
                    />
                    <q-select
                        v-model="customer.city"
                        label="شهر"
                        :options="citiesOptions"
                        option-label="City_Name"
                        option-value="City_ID"
                        @filter="filterCityFn"
                        use-chips
                        use-input
                        multiple
                    />
                    <q-select
                        v-model="customer.jobType"
                        label="صنف"
                        :options="customerKindsOptions"
                        option-label="CSKind_Name"
                        option-value="CsKind_ID"
                        @filter="filterKindFn"
                        use-chips
                        use-input
                        multiple
                    />
                  </q-card-section>
                </q-card>
              </q-popup-proxy>
            </q-btn>
          </template>
        </q-input>

        <div class="q-pa-md q-pa-sm justify-start">
          <q-btn label="تایید" type="submit" icon="search" color="primary"/>
          <q-btn label="انصراف" type="reset" icon="search_off" color="red" flat class="q-ml-sm"/>
        </div>
      </q-form>
    </q-card-section>

    <q-dialog
        :maximized="$q.screen.lt.md"
        v-model="insertCustomerDialog">
      <CUCustomerInfoLite action="insert" :buy-list="false" @customer-inserted="customerInserted"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from 'vuex';
import EventBus from "@/event-bus";
import CUCustomerInfoLite from "@/components/customers/CUCustomerInfoLite.vue";

export default {
  name: "OrderSearchPanel",
  components: {CUCustomerInfoLite},
  props: {
    isShopOrder: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      customer: {
        title: null,
        company: null,
        state: null,
        jobType: null,
        city: null
      },
      insertCustomerDialog: false,
      selectedCustomer: '',
      companies: [],
      states: [],
      cities: [],
      citiesOptions: [],
      statesOptions: [],
      customerKinds: [],
      customerKindsOptions: []
    }
  },
  methods: {
    ...mapActions({
      getCustomerByTitle: 'Customers/getByTitle',
      getCustomerSearchConstant: 'Customers/getCustomerSearchConstants',
      getCity: 'Customers/getCity'
    }),
    loadCustomerAddDialog() {
      this.insertCustomerDialog = true
    },
    customerInserted(args) {
      this.selectedCustomer = args
      EventBus.$emit('invoke-selected-customer', args);
    },
    onSubmit() {
      this.getCustomerByTitle({
        title: this.customer.title,
        company: this.customer.company !== null ? this.customer.company.map(item => item.CompID).join() : null,
        state: this.customer.state !== null ? this.customer.state.map(item => item.State_ID).join() : null,
        city: this.customer.city !== null ? this.customer.city.map(item => item.City_ID).join() : null,
        jobType: this.customer.jobType !== null ? this.customer.jobType.map(item => item.CSKind_ID).join() : null,
        isDeboter: false,
        isArchived: false,
        isBuyList: false
      }).then((data) => {
        EventBus.$emit('invoke-customer-search-result-event', data);
        EventBus.$emit('invoke-selected-customer', '');
        EventBus.$emit('invoke-product-search-result-event', []);
      });
    },
    onReset() {
      this.customer.title = '';
      EventBus.$emit('invoke-customer-search-result-event', []);
      EventBus.$emit('invoke-product-search-result-event', []);
      EventBus.$emit('invoke-selected-customer', '');
    },
    filterFn(val, update) {
      update(() => {
        this.statesOptions = this.states.filter(item => item.State_Name.includes(val))
      })
    },
    filterCityFn(val, update) {
      update(() => {
        this.customerKindsOptions = this.customerKinds.filter(item => item.CSKind_Name.includes(val))
      })
    },
    filterKindFn(val, update) {
      update(() => {
        this.customerKindsOptions = this.customerKinds.filter(item => item.CSKind_Name.includes(val))
      })
    }
  },
  watch: {
    'customer.state': function (val) {
      if (val.length === 0) {
        this.citiesOptions = []
      }
      this.getCity(val.map(item => item.State_ID).join()).then((res) => {
        this.cities = res;
        this.citiesOptions = this.cities;
      })
    }
  },
  created() {
    // if (!this.$router.currentRoute.params.id) {
    //   this.getCustomerSearchConstant().then((res) => {
    //     this.companies = eval(res.company);
    //     this.states = eval(res.customerState);
    //     this.statesOptions = this.states;
    //     this.customerKinds = eval(res.customerKind)
    //     this.customerKindsOptions = this.customerKinds
    //   })
    // }
  },
  mounted() {
    EventBus.$on('invoke-selected-customer', payload => {
      this.selectedCustomer = payload;
    });
  }
}
</script>

<style scoped>

</style>
